import ExtensionAction from './extension-action';

/**
 * Consent manager.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class ConsentManager extends ExtensionAction {
    constructor(container: HTMLElement) {
        super(container);
        this.initializeConsentButtons();
        ConsentManager.emitter.emit('ready', this);
    }

    /**
     * Initializes all additional consent buttons, e.g. within content elements, that enable a feature.
     */
    private initializeConsentButtons(): void {
        document.querySelectorAll<HTMLElement>('.consent-manager-preview .btn').forEach(item => {
            item.addEventListener('click', e => {
                if (item.dataset.enableFeature) {
                    ConsentManagerUtility.enableFeature(item.dataset.enableFeature);
                    ConsentManagerUtility.decodePlaceholders(item.dataset.enableFeature);
                    ConsentManagerUtility.decodeFeatures(item.dataset.enableFeature);
                }
                e.preventDefault();
            });
        });
    }
}
